import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { LazyTheWestLiveBillboard } from './TheWestLiveBillboard.lazy'
import { TheWestLiveBillboardProps } from './TheWestLiveBillboard'

export const TheWestLiveBillboardRegistration = createRegisterableComponent(
    'the-west-live-billboard',
    (props: TheWestLiveBillboardProps) => {
        return <LazyTheWestLiveBillboard {...props} />
    },
)
